import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PartModel } from './partModel';
import { PartModelService } from './partModel.service';
import { MediaService } from 'app/media/media.service';
import { NotificationService} from 'app/shared/notification/notification.service';
import { Media } from 'app/media/media';
import { Global } from 'app/core/global';
import { TableService } from 'app/core/models/pager';
import { MatTableDataSource } from '@angular/material';
import { HttpParams } from '@angular/common/http';

@Component({
	template: `
		<h3 class="title" i18n="@@update-partModel-pdf">Update Part Models pdfs</h3>

		<div class="tool-bar-wrap both-side">
			<div class="right row">
				<ng-template [hasPermission]="['MediaController.createPartModels']">
					<input id="file-upload" type="file" accept="application/pdf" (change)="create($event)" multiple>
					<label class="btn-file" for="file-upload">
						<i class="material-icons">add</i>
					</label>
				</ng-template>

				<ng-template [hasPermission]="['MediaController.delete']">
					<button class="btn-icon" i18n-title="@@option-delete" title="Delete" type="button" (click)="confirmDelete = false" *ngIf="tableService.selection.hasValue()">
						<i class="material-icons">delete</i>
					</button>
				</ng-template>
			</div>
		</div>

		<div class="mat-elevation-z8e" *ngIf="dataSource">
			<table mat-table [dataSource]="dataSource" matSort (matSortChange)="tableService.sortData($event); list();">
				<ng-container matColumnDef="select">
					<th mat-header-cell *matHeaderCellDef>
						<mat-checkbox (change)="tableService.masterToggle(dataSource.data)"
							[checked]="tableService.selection.hasValue() && tableService.isAllSelected(dataSource.data.length)"
							[indeterminate]="tableService.selection.hasValue() && !tableService.isAllSelected(dataSource.data.length)">
						</mat-checkbox>
					</th>
					<td mat-cell *matCellDef="let row">
						<mat-checkbox (click)="$event.stopPropagation()"
							(change)="tableService.selection.toggle(row)"
							[checked]="tableService.selection.isSelected(row)">
						</mat-checkbox>
					</td>
				</ng-container>

				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@name">Name</th>
					<td mat-cell *matCellDef="let element">{{element.name}}</td>
				</ng-container>

				<ng-container matColumnDef="createdAt">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@createdAt">Created date</th>
					<td mat-cell *matCellDef="let element">{{element.createdAt}}</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"
					(contextmenu)="tableService.selection.clear(); tableService.selection.select(row)" [contextMenu]="basicMenu" [contextMenuSubject]="row"
					(click)="read(row)">
				</tr>
			</table>

			<mat-paginator showFirstLastButtons
				[length]="tableService.pager.totalEntities"
				[pageIndex]="tableService.pager.pageIndex"
                [pageSize]="tableService.pager.pageSize"
				[pageSizeOptions]="[20, 50, 100]"
				(page)="list($event)">
			</mat-paginator>
		</div>

		<context-menu #basicMenu>
			<ng-template [hasPermission]="['PartModels.delete']">
				<ng-template contextMenuItem (execute)="confirmDelete = false">
					<div class="item">
						<i class="material-icons">delete</i>
						<span i18n="@@option-delete">Delete</span>
					</div>
				</ng-template>
			</ng-template>
		</context-menu>

		<modal-ns [(closed)]="confirmDelete">
			<ng-template modalContentDirective>
				<div class="dialog-content">
					<div class="dialog-title" i18n="@@confirm">Confirmation</div>
					<div class="dialog-message" i18n="@@confirm-deletes">Are you sure you want to delete the selected items?</div>
					<div class="options">
						<button class="btn-text red" type="button" (click)="confirmDelete = true">
							<span i18n="@@option-no">No</span>
						</button>
						<button class="btn-text green" type="button" (click)="deletes(); confirmDelete = true">
							<span i18n="@@option-yes">Yes</span>
						</button>
					</div>
				</div>
			</ng-template>
		</modal-ns>
	`,
	providers: [MediaService]
})
export class PartModelPdfComponent implements OnInit {
	dataSource: MatTableDataSource<Media>;
	displayedColumns: string[] = ['select', 'name', 'createdAt'];
	partModel: PartModel;
	confirmDelete = true;

	constructor(
		private activatedRoute: ActivatedRoute,
		private partModelService: PartModelService,
		private mediaService: MediaService,
		public tableService: TableService<Media>,
		private notificationService: NotificationService,
	) {}

	ngOnInit() {
		this.activatedRoute.parent.params.subscribe(params => {
			this.partModel = new PartModel();
			this.partModel.id = params['partModelId'];
			this.list();
		});
	}

	list(page = 0) {
		let httpParams = new HttpParams()
			.set('collection', '*, medias(id, multimediaCDN(*))');

		this.partModelService.getById(this.partModel.id, httpParams).subscribe(partModel => {
			this.partModel = partModel;
			let items = this.partModel.medias.filter(item => item.multimediaCDN.mimeType === 'application/pdf');
			this.dataSource = new MatTableDataSource<Media>(items);
			this.tableService.selection.clear();
		});
	}

	create(event) {
		if (event.target.files && event.target.files.length > 0) {
			let files: FileList = event.target.files;
			let promises = [];

			for (let i = 0; i < files.length; ++i) {
				let file = files.item(i);
				promises.push(new Promise((resolve, reject) => {
					MediaService.getBase64(file).then(data => {
						let media = new Media();
						media.name = file.name.substring(0, file.name.lastIndexOf('.'));
						media.multimediaCDN.mediaBase64 = data.toString();
						resolve(media);
					});
				}));
			}

			Promise.all(promises).then(items => {
				this.partModelService.createMedias(this.partModel.id, items).subscribe(medias => {
					this.notificationService.sucessInsert();
					this.dataSource.data.push(...medias);
				});
			}, err => this.notificationService.error(err));
		}
	}

	read(item: Media) {
		window.open(item.multimediaCDN.url, '_blank');
	}

	deletes() {
		if (this.tableService.selection.selected.length === 1) {
			let item = this.tableService.selection.selected[0];
			this.mediaService.delete(item.id).subscribe(data => {
				this.notificationService.sucessDelete();
				this.list();
			}, err => this.notificationService.error(err));

		} else if (this.tableService.selection.selected.length > 1) {
			let keys = Global.getProperties(this.tableService.selection.selected, 'id');
			this.mediaService.deletes({'ids': keys}).subscribe(data => {
				this.notificationService.sucessDelete();
				this.list();
			}, err => this.notificationService.error(err));
		}
	}
}
